import './App.css';
import React from 'react';
import {
  Button,
  Card,
  Grid,
} from '@mui/material';

import {
  HashRouter as Router,
  Routes,
  Route,
  Link
} from "react-router-dom";

import Page1 from './Page1';
import Page2 from './Page2';

function App() {
  return (
    <Router>
      <React.Fragment>
        
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={5}
          paddingTop={5}
        >
          {/* <Grid item md={12}></Grid> */}
          {/* <Grid item md={2}></Grid> */}
          {/* <Grid item>
            <Button variant='contained' component={Link} to={"/"} sx={{
              ':hover': {
                'bgcolor': '#f23731',
                  'color': '#fff'
              },
              'color': '#fff',
              'bgcolor': '#f4534e',
              'text-transform': 'none'
            }}>Rechtsanwaltschaftsprüfung</Button>


          </Grid>
          <Grid item>
            <Button variant='contained' component={Link} to={"/RAA"} sx={{
              ':hover': {
                'bgcolor': '#f23731',
                  'color': '#fff'
              },
              'color': '#fff',
              'bgcolor': '#f4534e',
              'text-transform': 'none'
            }}>Anwält*innen und Anwärter*innen</Button>


          </Grid> */}
          {/* <Grid item md={2}></Grid> */}
        </Grid>
        <Grid container spacing={10}>
          <Grid item md={12}>

            {/* <Link to="/">Page1</Link>
            <Link to="/page2">Page2</Link> */}

            <Routes>
              <Route path="/" element={<Page1 />} />
              <Route path="/RAA" element={<Page2 />} />
            </Routes>

          </Grid>
        </Grid>

      </React.Fragment>
    </Router>
  );
}

export default App;
